export default function scrollToTop(element, data) {
    const targetClasses = [
        'main__green-block', 'about_goals', 'about__join',
        'application__form_block', 'about__join about__join_2'
    ];

    element.addEventListener("click", () => 
        window.scrollTo({ top: 0, behavior: 'smooth' })
    );

    window.addEventListener('scroll', () => {
        const scrollPos = window.scrollY;

        // Видимость кнопки
        if (scrollPos > 200) {
            element.classList.add("visible");
        } else {
            element.classList.remove("visible");
        }

        const elRect = element.getBoundingClientRect();
        const centerX = elRect.left + elRect.width / 2;
        const centerY = elRect.top + elRect.height / 2;
        let elementBelow = document.elementFromPoint(centerX, centerY);

        if (element.contains(elementBelow)) {
            elementBelow = document.elementFromPoint(centerX, centerY + element.offsetHeight / 2);
        }

        let isOverTargetBlock = false;
        while (elementBelow && elementBelow !== document.body) {
            
            if (targetClasses.some(cls => elementBelow.classList.contains(cls))) {
                isOverTargetBlock = true;
                break;
            }
            elementBelow = elementBelow.parentElement;
        }

        if (isOverTargetBlock) {
            element.classList.add('on-green');
        } else {
            element.classList.remove('on-green');
        }
    }, { passive: true });
}